import {
  Container,
  Name,
} from "./styles"
import useResponsive from "utils/hooks/useResponsive";
import { Avatar, FlixxBalanceMobile } from "ui";
import { useLocation, useSession } from "hooks";

const AvatarDropdownUser = () => {
 
  const { user } = useSession()

  const { isCreators } = useLocation()
  const { isTab } = useResponsive()

  return (
    <Container $isCreators={isCreators}>
      <Avatar src={user.profile.avatar} />
      <div>
        <Name $isCreators={isCreators}>
          {user.nickname}
        </Name>
        {isTab && <FlixxBalanceMobile />}
      </div>
    </Container>
  )
}

export default AvatarDropdownUser